<!-- Menu header -->
<div class="navbar-header">
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item ">
      <!-- App Branding -->
      <a class="navbar-brand" [href]="resolveHomeRoute()">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo"/>
        </span>
        <div class="title-container">
          <div class="row">
            <h5 class="brand-text mb-0 ms-0 ps-0">Caleidoscoop</h5>
          </div>
          <div class="row">
            <h5 class="brand-text mb-0 ms-0 ps-0">Academie</h5>
          </div>
        </div>
      </a>
    </li>

    <!-- Menu Toggler -->
    <li class="nav-item nav-toggle">
      <a (click)="toggleSidebarCollapsible()" class="nav-link disc-margin d-none d-xl-block pe-0 pt-1 ps-1">
        <i
          [ngClass]="isCollapsed === true ? 'icon-circle' : 'icon-disc'"
          class="toggle-icon feather font-medium-4 collapse-toggle-icon text-primary"
        ></i>
      </a>
      <a (click)="toggleSidebar()" class="nav-link modern-nav-toggle d-block d-xl-none pe-0 x-icon-margin-top">
        <i data-feather="x" class="font-medium-4 text-primary toggle-icon"></i>
      </a>
    </li>
  </ul>
</div>
<!--/ Menu header -->

<!-- Navbar shadow -->
<div class="shadow-bottom" [ngClass]="{ 'd-block': isScrolled }"></div>
<br/>
<!-- Main menu -->
<ng-scrollbar class="main-menu-content mt-2" trackX="false" (scroll)="onSidebarScroll()">
  <ul class="navigation navigation-main" layout="vertical" core-menu></ul>
</ng-scrollbar>
<!--/ Main menu -->
